import React from 'react'
import TextTitle from 'components/TextTitle'
import Block from 'components/Block'
import TextBody from 'components/TextBody'
import ButtonPrimary from 'components/ButtonPrimary'
import {
  STYLES_ALIGN_ITEMS,
  STYLES_COLOR
} from 'modules/styles/constants/index.cjs'
import { View } from 'components/View'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { CountdownSection } from 'components/CountdownSection/index.js'

export default function BannerSection ({
  title,
  subTitle,
  buttonText,
  onClickButton,
  url,
  endDate,
  bannerImgSrc,
  startDateText,
  endDateText
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)

  return (
    <Block
      style={{
        backgroundImage: `url(${bannerImgSrc})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: isSmallScreen
          ? 'unset'
          : '723px',
        backgroundPositionX: '60%'
      }}
    >
      <TextTitle
        fs={isSmallScreen
          ? '1.75em'
          : '3.75em'}
        mt
        c={STYLES_COLOR.WHITE}
        style={{
          textAlign: STYLES_ALIGN_ITEMS.CENTER
        }}
      >
        {title}
      </TextTitle>
      <TextBody
        fs={isSmallScreen
          ? '1em'
          : '1.5em'}
        mt={isSmallScreen
          ? '1.0231em'
          : '1.727em'}
        mb='2.3em'
        c={STYLES_COLOR.WHITE}
        style={{
          textAlign: STYLES_ALIGN_ITEMS.CENTER
        }}
      >
        {subTitle}
      </TextBody>
      {buttonText && (
        <ButtonPrimary
          url={url}
          onClick={onClickButton}
        >
          {buttonText}
        </ButtonPrimary>
      )}
      {endDate && (
        <>
          <View
            row={!isSmallScreen}
            w='800px'
            style={{ justifyContent: 'space-between' }}
          >
            <TextBody
              fs={isSmallScreen
                ? '1em'
                : '1.5em'}
              c={STYLES_COLOR.WHITE}
              style={{
                textAlign: STYLES_ALIGN_ITEMS.CENTER
              }}
            >
              {startDateText}
            </TextBody>
            <TextBody
              fs={isSmallScreen
                ? '1em'
                : '1.5em'}
              mt={isSmallScreen
                ? '0.8em'
                : 0}
              c={STYLES_COLOR.WHITE}
              style={{
                textAlign: STYLES_ALIGN_ITEMS.CENTER
              }}
            >
              {endDateText}
            </TextBody>
          </View>
          <View mt={2}>
            <ButtonPrimary
              url={url}
              onClick={onClickButton}
            >
              {buttonText}
            </ButtonPrimary>
          </View>
          <View mt='1.54em'>
            <CountdownSection end={endDate} />
          </View>
        </>
      )}
    </Block>
  )
}
